import partial from 'lodash/partial'
import PropTypes from 'prop-types'
import React, {useState} from 'react'

import useOnUnmount from '../../../../hooks/useOnUnmount'
import {OtherEventLookNames, WeddingEventLookNames} from '../../../../store/enum'

import Button from '../../../Fields/Button'
import Throbber from '../../../Throbber'

const lookNames = [
  {
    title: 'WEDDING RELATED',
    className: 'look-types wedding',
    names: [
      WeddingEventLookNames.groom,
      WeddingEventLookNames.groomsman,
      WeddingEventLookNames.weddingParty,
      WeddingEventLookNames.ushers,
      WeddingEventLookNames.fatherBride,
      WeddingEventLookNames.fatherGroom,
      WeddingEventLookNames.weddingGuest,
      WeddingEventLookNames.officiant,
    ],
  },
  {
    title: 'OTHER',
    className: 'look-types other',
    names: [OtherEventLookNames.specialEvent, OtherEventLookNames.prom],
  },
]

const DELAY = 5000

const LookNamePanel = ({onLookClicked}) => {
  const [timeoutId, setTimeoutId] = useState()
  const [workingName, setWorkingName] = useState()

  useOnUnmount(() => {
    clearTimeout(timeoutId)
    setTimeoutId()
  })

  function resetWorkingName() {
    setWorkingName()
  }

  function startResetWorkingNameTimer() {
    setTimeoutId(setTimeout(resetWorkingName, DELAY))
  }

  function handleLookNameClick(name) {
    if (!workingName) {
      onLookClicked(name)
      setWorkingName(name)
      startResetWorkingNameTimer()
    }
  }

  return (
    <div className="look-name-panel">
      <h2>
        Select a Name for{' '}
        <span className="hide-from-medium-tablet">
          <br />
        </span>
        Your Look
      </h2>
      {lookNames.map(({className, names, title}) => (
        <div key={title} className={className}>
          <h3>{title}</h3>
          <ul>
            {names.map((name) => (
              <li key={name} className={name.replace(/\s+/g, '')}>
                <div className="look-name-item-inner">
                  {workingName === name ? (
                    <Throbber />
                  ) : (
                    <Button onClick={partial(handleLookNameClick, name)}>{name}</Button>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  )
}

LookNamePanel.propTypes = {
  onLookClicked: PropTypes.func.isRequired,
}

export default LookNamePanel
